import { customAxios } from './customAxios';

/**
 * kakao api 이용하여 주소 검색
 * dh
 * 
 * @param {*} address 
 * @param {*} t 
 * @returns 
 */
export const getCoordsByAddress = async(address, t)=>{
  const res = await customAxios.get('/api/public/map/coordinate', {params : {address}});
  if (res) {
    const docs = res.data.documents;
    if (docs.length === 0) throw new Error(t('message.common.error.text.correct.address.input'));
    return res.data;
  }
  return null;
}

/**
 * 중국 level별 지역코드를 이용해서 주소 검색
 * dh
 * 2026-08-14
 * 
 * @param {*} address 
 * @returns 
 */
export const getCoordsByAddressZh = async(address)=>{
  const res = await customAxios.get('/api/public/china-regions/search', {params : {keyword:address}});
  if (res.data) {
    return res.data;
  }
  return null;
}